<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Users Permissions Master Data</h1>
          <p>Enter Users Permissions Details Master Data below to stay updated </p>
      </div>
</div>
</section>
<section class="w3l-hero-headers-11 p-sticky-md">
  <div class="top-header">
          <div class="d-grid grid-columns-top-3">
              <div class="accounts">
                  <ul>
                      <li></li>
                      <li></li>
                  </ul>
              </div>

          </div>
  </div>
</section>
<div id="w3l-appointment">
<section class="appointment-section section-gap">

<div class="wrapper">
<div class="d-grid doctor-appointment">
    <div class="appointment-form">
        <form action="#" method="post">
            <div class="fields-grid">
              <div class="styled-input">
                <label>User Group</label>
                <div class="appointment-form-field">
                    <span class="fa fa-sitemap" aria-hidden="true"></span>
                    <select id="Group" name="Group" required="" [(ngModel)]="userID" [value]="userID" (change)="retriveUserPerm()">
                      <option value="{{grp.groupsCode}}" *ngFor="let grp of groupsList; let i = index">{{grp.groupsName}}</option>

                    </select>
                </div>
            </div>


                    <label style="font-size: 12; font-weight: bold;color: mediumblue;" for= "Admin">Admin</label>
                    <div class="login-remember d-grid">
                        <div class="styled-input">
                          <input type="radio" name="admin" value="Not" checked [(ngModel)]="usAdmin" > Not Allowed    
                          <input type="radio" name="admin" value="Read" [(ngModel)]="usAdmin"> Read Only    
                          <input type="radio" name="admin" value="Full" [(ngModel)]="usAdmin"> Full Control

                      </div>
                    </div>


                <label style="font-size: 12; font-weight: bold;color: mediumblue;">Staff</label>
                  <div class="login-remember d-grid">
                    <div class="styled-input">
                      <input type="radio" name="admin1" value="Not" checked [(ngModel)]="usStaff"> Not Allowed    
                      <input type="radio" name="admin1" value="Read" [(ngModel)]="usStaff"> Read Only    
                      <input type="radio" name="admin1" value="Full" [(ngModel)]="usStaff"> Full Control
                </div>
                  </div>

              </div>

                <label style="font-size: 12; font-weight: bold;color: mediumblue;">Oncologist </label>
                <div class="login-remember d-grid">
                    <div class="styled-input">
                      <input type="radio" name="admin2" value="Not" checked [(ngModel)]="usOncologist"> Not Allowed    
                      <input type="radio" name="admin2" value="Read" [(ngModel)]="usOncologist"> Read Only    
                      <input type="radio" name="admin2" value="Full" [(ngModel)]="usOncologist"> Full Control
                  </div>

            </div>

              <label style="font-size: 12; font-weight: bold;color: mediumblue;">Pharmatheutical</label>
              <div class="login-remember d-grid">
                  <div class="styled-input">
                    <input type="radio" name="admin4" value="Not" checked [(ngModel)]="usPharma"> Not Allowed    
                    <input type="radio" name="admin4" value="Read"  [(ngModel)]="usPharma"> Read Only    
                    <input type="radio" name="admin4" value="Full"  [(ngModel)]="usPharma"> Full Control
              </div>

            </div>

              <label style="font-size: 12; font-weight: bold;color: mediumblue;">Accounting</label>
              <div class="login-remember d-grid">
                  <div class="styled-input">
                      <input type="radio" name="admin5" value="Not" checked  [(ngModel)]="usAccounting" > Not Allowed    
                      <input type="radio" name="admin5" value="Read" [(ngModel)]="usAccounting"> Read Only    
                      <input type="radio" name="admin5" value="Full" [(ngModel)]="usAccounting"> Full Control

                </div>
              </div>



                <button type="button" class="theme-button btn" name="submit" (click)="submitUserPerm()">Submit</button>
                <button type="button" class="theme-button btn" name="Delete" disabled >Delete</button>
                <button type="button" class="theme-button btn" name="New" (click)="NewData()">New</button>
                <a href="Home">
                <button type="button" class="theme-button btn" style="width: 83%;" name="Back">Home</button>
                </a>
                <div class="clear"> </div>

        </form>
    </div>

    <div class="registerimg">
      <BR>
      <BR>
      <BR>
        <img src="assets/images/cybersecurity.jpeg" alt="" />
    </div>
</div>
<div class="clear"> </div>
</div>
</section>
</div>
